/**
 * @fileoverview gRPC-Web generated client stub for vendormanagement
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: vendormanagement/vendormanagement.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var common_sorting_pb = require('../common/sorting_pb.js')

var authz_annotations_pb = require('../authz/annotations_pb.js')

var vendormanagement_vendor_evaluation_cycle_pb = require('../vendormanagement/vendor_evaluation_cycle_pb.js')
const proto = {};
proto.vendormanagement = require('./vendormanagement_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.vendormanagement.VendorClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.vendormanagement.VendorPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.vendormanagement.ListVendorEvaluationsRequest,
 *   !proto.vendormanagement.ListVendorEvaluationsResponse>}
 */
const methodDescriptor_Vendor_ListVendorEvaluations = new grpc.web.MethodDescriptor(
  '/vendormanagement.Vendor/ListVendorEvaluations',
  grpc.web.MethodType.UNARY,
  vendormanagement_vendor_evaluation_cycle_pb.ListVendorEvaluationsRequest,
  vendormanagement_vendor_evaluation_cycle_pb.ListVendorEvaluationsResponse,
  /**
   * @param {!proto.vendormanagement.ListVendorEvaluationsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  vendormanagement_vendor_evaluation_cycle_pb.ListVendorEvaluationsResponse.deserializeBinary
);


/**
 * @param {!proto.vendormanagement.ListVendorEvaluationsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.vendormanagement.ListVendorEvaluationsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.vendormanagement.ListVendorEvaluationsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.vendormanagement.VendorClient.prototype.listVendorEvaluations =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/vendormanagement.Vendor/ListVendorEvaluations',
      request,
      metadata || {},
      methodDescriptor_Vendor_ListVendorEvaluations,
      callback);
};


/**
 * @param {!proto.vendormanagement.ListVendorEvaluationsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.vendormanagement.ListVendorEvaluationsResponse>}
 *     Promise that resolves to the response
 */
proto.vendormanagement.VendorPromiseClient.prototype.listVendorEvaluations =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/vendormanagement.Vendor/ListVendorEvaluations',
      request,
      metadata || {},
      methodDescriptor_Vendor_ListVendorEvaluations);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.vendormanagement.StartVendorEvaluationRequest,
 *   !proto.vendormanagement.VendorEvaluationCycle>}
 */
const methodDescriptor_Vendor_StartVendorEvaluation = new grpc.web.MethodDescriptor(
  '/vendormanagement.Vendor/StartVendorEvaluation',
  grpc.web.MethodType.UNARY,
  vendormanagement_vendor_evaluation_cycle_pb.StartVendorEvaluationRequest,
  vendormanagement_vendor_evaluation_cycle_pb.VendorEvaluationCycle,
  /**
   * @param {!proto.vendormanagement.StartVendorEvaluationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  vendormanagement_vendor_evaluation_cycle_pb.VendorEvaluationCycle.deserializeBinary
);


/**
 * @param {!proto.vendormanagement.StartVendorEvaluationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.vendormanagement.VendorEvaluationCycle)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.vendormanagement.VendorEvaluationCycle>|undefined}
 *     The XHR Node Readable Stream
 */
proto.vendormanagement.VendorClient.prototype.startVendorEvaluation =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/vendormanagement.Vendor/StartVendorEvaluation',
      request,
      metadata || {},
      methodDescriptor_Vendor_StartVendorEvaluation,
      callback);
};


/**
 * @param {!proto.vendormanagement.StartVendorEvaluationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.vendormanagement.VendorEvaluationCycle>}
 *     Promise that resolves to the response
 */
proto.vendormanagement.VendorPromiseClient.prototype.startVendorEvaluation =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/vendormanagement.Vendor/StartVendorEvaluation',
      request,
      metadata || {},
      methodDescriptor_Vendor_StartVendorEvaluation);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.vendormanagement.CancelVendorEvaluationRequest,
 *   !proto.vendormanagement.VendorEvaluationCycle>}
 */
const methodDescriptor_Vendor_CancelVendorEvaluation = new grpc.web.MethodDescriptor(
  '/vendormanagement.Vendor/CancelVendorEvaluation',
  grpc.web.MethodType.UNARY,
  vendormanagement_vendor_evaluation_cycle_pb.CancelVendorEvaluationRequest,
  vendormanagement_vendor_evaluation_cycle_pb.VendorEvaluationCycle,
  /**
   * @param {!proto.vendormanagement.CancelVendorEvaluationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  vendormanagement_vendor_evaluation_cycle_pb.VendorEvaluationCycle.deserializeBinary
);


/**
 * @param {!proto.vendormanagement.CancelVendorEvaluationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.vendormanagement.VendorEvaluationCycle)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.vendormanagement.VendorEvaluationCycle>|undefined}
 *     The XHR Node Readable Stream
 */
proto.vendormanagement.VendorClient.prototype.cancelVendorEvaluation =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/vendormanagement.Vendor/CancelVendorEvaluation',
      request,
      metadata || {},
      methodDescriptor_Vendor_CancelVendorEvaluation,
      callback);
};


/**
 * @param {!proto.vendormanagement.CancelVendorEvaluationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.vendormanagement.VendorEvaluationCycle>}
 *     Promise that resolves to the response
 */
proto.vendormanagement.VendorPromiseClient.prototype.cancelVendorEvaluation =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/vendormanagement.Vendor/CancelVendorEvaluation',
      request,
      metadata || {},
      methodDescriptor_Vendor_CancelVendorEvaluation);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.vendormanagement.ListVendorsRequest,
 *   !proto.vendormanagement.ListVendorsResponse>}
 */
const methodDescriptor_Vendor_ListVendors = new grpc.web.MethodDescriptor(
  '/vendormanagement.Vendor/ListVendors',
  grpc.web.MethodType.UNARY,
  proto.vendormanagement.ListVendorsRequest,
  proto.vendormanagement.ListVendorsResponse,
  /**
   * @param {!proto.vendormanagement.ListVendorsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.vendormanagement.ListVendorsResponse.deserializeBinary
);


/**
 * @param {!proto.vendormanagement.ListVendorsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.vendormanagement.ListVendorsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.vendormanagement.ListVendorsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.vendormanagement.VendorClient.prototype.listVendors =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/vendormanagement.Vendor/ListVendors',
      request,
      metadata || {},
      methodDescriptor_Vendor_ListVendors,
      callback);
};


/**
 * @param {!proto.vendormanagement.ListVendorsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.vendormanagement.ListVendorsResponse>}
 *     Promise that resolves to the response
 */
proto.vendormanagement.VendorPromiseClient.prototype.listVendors =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/vendormanagement.Vendor/ListVendors',
      request,
      metadata || {},
      methodDescriptor_Vendor_ListVendors);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.vendormanagement.GetVendorRequest,
 *   !proto.vendormanagement.VendorRecord>}
 */
const methodDescriptor_Vendor_GetVendor = new grpc.web.MethodDescriptor(
  '/vendormanagement.Vendor/GetVendor',
  grpc.web.MethodType.UNARY,
  proto.vendormanagement.GetVendorRequest,
  proto.vendormanagement.VendorRecord,
  /**
   * @param {!proto.vendormanagement.GetVendorRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.vendormanagement.VendorRecord.deserializeBinary
);


/**
 * @param {!proto.vendormanagement.GetVendorRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.vendormanagement.VendorRecord)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.vendormanagement.VendorRecord>|undefined}
 *     The XHR Node Readable Stream
 */
proto.vendormanagement.VendorClient.prototype.getVendor =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/vendormanagement.Vendor/GetVendor',
      request,
      metadata || {},
      methodDescriptor_Vendor_GetVendor,
      callback);
};


/**
 * @param {!proto.vendormanagement.GetVendorRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.vendormanagement.VendorRecord>}
 *     Promise that resolves to the response
 */
proto.vendormanagement.VendorPromiseClient.prototype.getVendor =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/vendormanagement.Vendor/GetVendor',
      request,
      metadata || {},
      methodDescriptor_Vendor_GetVendor);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.vendormanagement.CreateVendorsRequest,
 *   !proto.vendormanagement.Vendors>}
 */
const methodDescriptor_Vendor_CreateVendors = new grpc.web.MethodDescriptor(
  '/vendormanagement.Vendor/CreateVendors',
  grpc.web.MethodType.UNARY,
  proto.vendormanagement.CreateVendorsRequest,
  proto.vendormanagement.Vendors,
  /**
   * @param {!proto.vendormanagement.CreateVendorsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.vendormanagement.Vendors.deserializeBinary
);


/**
 * @param {!proto.vendormanagement.CreateVendorsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.vendormanagement.Vendors)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.vendormanagement.Vendors>|undefined}
 *     The XHR Node Readable Stream
 */
proto.vendormanagement.VendorClient.prototype.createVendors =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/vendormanagement.Vendor/CreateVendors',
      request,
      metadata || {},
      methodDescriptor_Vendor_CreateVendors,
      callback);
};


/**
 * @param {!proto.vendormanagement.CreateVendorsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.vendormanagement.Vendors>}
 *     Promise that resolves to the response
 */
proto.vendormanagement.VendorPromiseClient.prototype.createVendors =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/vendormanagement.Vendor/CreateVendors',
      request,
      metadata || {},
      methodDescriptor_Vendor_CreateVendors);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.vendormanagement.UpdateVendorsRequest,
 *   !proto.vendormanagement.Vendors>}
 */
const methodDescriptor_Vendor_UpdateVendors = new grpc.web.MethodDescriptor(
  '/vendormanagement.Vendor/UpdateVendors',
  grpc.web.MethodType.UNARY,
  proto.vendormanagement.UpdateVendorsRequest,
  proto.vendormanagement.Vendors,
  /**
   * @param {!proto.vendormanagement.UpdateVendorsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.vendormanagement.Vendors.deserializeBinary
);


/**
 * @param {!proto.vendormanagement.UpdateVendorsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.vendormanagement.Vendors)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.vendormanagement.Vendors>|undefined}
 *     The XHR Node Readable Stream
 */
proto.vendormanagement.VendorClient.prototype.updateVendors =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/vendormanagement.Vendor/UpdateVendors',
      request,
      metadata || {},
      methodDescriptor_Vendor_UpdateVendors,
      callback);
};


/**
 * @param {!proto.vendormanagement.UpdateVendorsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.vendormanagement.Vendors>}
 *     Promise that resolves to the response
 */
proto.vendormanagement.VendorPromiseClient.prototype.updateVendors =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/vendormanagement.Vendor/UpdateVendors',
      request,
      metadata || {},
      methodDescriptor_Vendor_UpdateVendors);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.vendormanagement.DeleteVendorRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Vendor_DeleteVendor = new grpc.web.MethodDescriptor(
  '/vendormanagement.Vendor/DeleteVendor',
  grpc.web.MethodType.UNARY,
  proto.vendormanagement.DeleteVendorRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.vendormanagement.DeleteVendorRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.vendormanagement.DeleteVendorRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.vendormanagement.VendorClient.prototype.deleteVendor =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/vendormanagement.Vendor/DeleteVendor',
      request,
      metadata || {},
      methodDescriptor_Vendor_DeleteVendor,
      callback);
};


/**
 * @param {!proto.vendormanagement.DeleteVendorRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.vendormanagement.VendorPromiseClient.prototype.deleteVendor =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/vendormanagement.Vendor/DeleteVendor',
      request,
      metadata || {},
      methodDescriptor_Vendor_DeleteVendor);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.vendormanagement.SetVendorAssigneesRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Vendor_SetVendorAssignees = new grpc.web.MethodDescriptor(
  '/vendormanagement.Vendor/SetVendorAssignees',
  grpc.web.MethodType.UNARY,
  proto.vendormanagement.SetVendorAssigneesRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.vendormanagement.SetVendorAssigneesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.vendormanagement.SetVendorAssigneesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.vendormanagement.VendorClient.prototype.setVendorAssignees =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/vendormanagement.Vendor/SetVendorAssignees',
      request,
      metadata || {},
      methodDescriptor_Vendor_SetVendorAssignees,
      callback);
};


/**
 * @param {!proto.vendormanagement.SetVendorAssigneesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.vendormanagement.VendorPromiseClient.prototype.setVendorAssignees =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/vendormanagement.Vendor/SetVendorAssignees',
      request,
      metadata || {},
      methodDescriptor_Vendor_SetVendorAssignees);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.vendormanagement.AddVendorUserRequest,
 *   !proto.vendormanagement.VendorUserRecord>}
 */
const methodDescriptor_Vendor_AddVendorUser = new grpc.web.MethodDescriptor(
  '/vendormanagement.Vendor/AddVendorUser',
  grpc.web.MethodType.UNARY,
  proto.vendormanagement.AddVendorUserRequest,
  proto.vendormanagement.VendorUserRecord,
  /**
   * @param {!proto.vendormanagement.AddVendorUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.vendormanagement.VendorUserRecord.deserializeBinary
);


/**
 * @param {!proto.vendormanagement.AddVendorUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.vendormanagement.VendorUserRecord)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.vendormanagement.VendorUserRecord>|undefined}
 *     The XHR Node Readable Stream
 */
proto.vendormanagement.VendorClient.prototype.addVendorUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/vendormanagement.Vendor/AddVendorUser',
      request,
      metadata || {},
      methodDescriptor_Vendor_AddVendorUser,
      callback);
};


/**
 * @param {!proto.vendormanagement.AddVendorUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.vendormanagement.VendorUserRecord>}
 *     Promise that resolves to the response
 */
proto.vendormanagement.VendorPromiseClient.prototype.addVendorUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/vendormanagement.Vendor/AddVendorUser',
      request,
      metadata || {},
      methodDescriptor_Vendor_AddVendorUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.vendormanagement.UpdateVendorUserRequest,
 *   !proto.vendormanagement.VendorUserRecord>}
 */
const methodDescriptor_Vendor_UpdateVendorUser = new grpc.web.MethodDescriptor(
  '/vendormanagement.Vendor/UpdateVendorUser',
  grpc.web.MethodType.UNARY,
  proto.vendormanagement.UpdateVendorUserRequest,
  proto.vendormanagement.VendorUserRecord,
  /**
   * @param {!proto.vendormanagement.UpdateVendorUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.vendormanagement.VendorUserRecord.deserializeBinary
);


/**
 * @param {!proto.vendormanagement.UpdateVendorUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.vendormanagement.VendorUserRecord)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.vendormanagement.VendorUserRecord>|undefined}
 *     The XHR Node Readable Stream
 */
proto.vendormanagement.VendorClient.prototype.updateVendorUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/vendormanagement.Vendor/UpdateVendorUser',
      request,
      metadata || {},
      methodDescriptor_Vendor_UpdateVendorUser,
      callback);
};


/**
 * @param {!proto.vendormanagement.UpdateVendorUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.vendormanagement.VendorUserRecord>}
 *     Promise that resolves to the response
 */
proto.vendormanagement.VendorPromiseClient.prototype.updateVendorUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/vendormanagement.Vendor/UpdateVendorUser',
      request,
      metadata || {},
      methodDescriptor_Vendor_UpdateVendorUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.vendormanagement.RemoveVendorUserRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Vendor_RemoveVendorUser = new grpc.web.MethodDescriptor(
  '/vendormanagement.Vendor/RemoveVendorUser',
  grpc.web.MethodType.UNARY,
  proto.vendormanagement.RemoveVendorUserRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.vendormanagement.RemoveVendorUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.vendormanagement.RemoveVendorUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.vendormanagement.VendorClient.prototype.removeVendorUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/vendormanagement.Vendor/RemoveVendorUser',
      request,
      metadata || {},
      methodDescriptor_Vendor_RemoveVendorUser,
      callback);
};


/**
 * @param {!proto.vendormanagement.RemoveVendorUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.vendormanagement.VendorPromiseClient.prototype.removeVendorUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/vendormanagement.Vendor/RemoveVendorUser',
      request,
      metadata || {},
      methodDescriptor_Vendor_RemoveVendorUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.vendormanagement.ListVendorUsersRequest,
 *   !proto.vendormanagement.ListVendorUsersResponse>}
 */
const methodDescriptor_Vendor_ListVendorUsers = new grpc.web.MethodDescriptor(
  '/vendormanagement.Vendor/ListVendorUsers',
  grpc.web.MethodType.UNARY,
  proto.vendormanagement.ListVendorUsersRequest,
  proto.vendormanagement.ListVendorUsersResponse,
  /**
   * @param {!proto.vendormanagement.ListVendorUsersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.vendormanagement.ListVendorUsersResponse.deserializeBinary
);


/**
 * @param {!proto.vendormanagement.ListVendorUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.vendormanagement.ListVendorUsersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.vendormanagement.ListVendorUsersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.vendormanagement.VendorClient.prototype.listVendorUsers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/vendormanagement.Vendor/ListVendorUsers',
      request,
      metadata || {},
      methodDescriptor_Vendor_ListVendorUsers,
      callback);
};


/**
 * @param {!proto.vendormanagement.ListVendorUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.vendormanagement.ListVendorUsersResponse>}
 *     Promise that resolves to the response
 */
proto.vendormanagement.VendorPromiseClient.prototype.listVendorUsers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/vendormanagement.Vendor/ListVendorUsers',
      request,
      metadata || {},
      methodDescriptor_Vendor_ListVendorUsers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.vendormanagement.VendorStatuses>}
 */
const methodDescriptor_Vendor_ListVendorStatuses = new grpc.web.MethodDescriptor(
  '/vendormanagement.Vendor/ListVendorStatuses',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.vendormanagement.VendorStatuses,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.vendormanagement.VendorStatuses.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.vendormanagement.VendorStatuses)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.vendormanagement.VendorStatuses>|undefined}
 *     The XHR Node Readable Stream
 */
proto.vendormanagement.VendorClient.prototype.listVendorStatuses =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/vendormanagement.Vendor/ListVendorStatuses',
      request,
      metadata || {},
      methodDescriptor_Vendor_ListVendorStatuses,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.vendormanagement.VendorStatuses>}
 *     Promise that resolves to the response
 */
proto.vendormanagement.VendorPromiseClient.prototype.listVendorStatuses =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/vendormanagement.Vendor/ListVendorStatuses',
      request,
      metadata || {},
      methodDescriptor_Vendor_ListVendorStatuses);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.vendormanagement.CreateOrUpdateVendorStatusesRequest,
 *   !proto.vendormanagement.VendorStatuses>}
 */
const methodDescriptor_Vendor_CreateOrUpdateVendorStatuses = new grpc.web.MethodDescriptor(
  '/vendormanagement.Vendor/CreateOrUpdateVendorStatuses',
  grpc.web.MethodType.UNARY,
  proto.vendormanagement.CreateOrUpdateVendorStatusesRequest,
  proto.vendormanagement.VendorStatuses,
  /**
   * @param {!proto.vendormanagement.CreateOrUpdateVendorStatusesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.vendormanagement.VendorStatuses.deserializeBinary
);


/**
 * @param {!proto.vendormanagement.CreateOrUpdateVendorStatusesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.vendormanagement.VendorStatuses)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.vendormanagement.VendorStatuses>|undefined}
 *     The XHR Node Readable Stream
 */
proto.vendormanagement.VendorClient.prototype.createOrUpdateVendorStatuses =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/vendormanagement.Vendor/CreateOrUpdateVendorStatuses',
      request,
      metadata || {},
      methodDescriptor_Vendor_CreateOrUpdateVendorStatuses,
      callback);
};


/**
 * @param {!proto.vendormanagement.CreateOrUpdateVendorStatusesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.vendormanagement.VendorStatuses>}
 *     Promise that resolves to the response
 */
proto.vendormanagement.VendorPromiseClient.prototype.createOrUpdateVendorStatuses =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/vendormanagement.Vendor/CreateOrUpdateVendorStatuses',
      request,
      metadata || {},
      methodDescriptor_Vendor_CreateOrUpdateVendorStatuses);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.vendormanagement.DeleteVendorStatusRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Vendor_DeleteVendorStatus = new grpc.web.MethodDescriptor(
  '/vendormanagement.Vendor/DeleteVendorStatus',
  grpc.web.MethodType.UNARY,
  proto.vendormanagement.DeleteVendorStatusRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.vendormanagement.DeleteVendorStatusRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.vendormanagement.DeleteVendorStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.vendormanagement.VendorClient.prototype.deleteVendorStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/vendormanagement.Vendor/DeleteVendorStatus',
      request,
      metadata || {},
      methodDescriptor_Vendor_DeleteVendorStatus,
      callback);
};


/**
 * @param {!proto.vendormanagement.DeleteVendorStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.vendormanagement.VendorPromiseClient.prototype.deleteVendorStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/vendormanagement.Vendor/DeleteVendorStatus',
      request,
      metadata || {},
      methodDescriptor_Vendor_DeleteVendorStatus);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.vendormanagement.ListVendorEvaluationCriteriaRequest,
 *   !proto.vendormanagement.ListVendorEvaluationCriteriaResponse>}
 */
const methodDescriptor_Vendor_ListVendorEvaluationCriteria = new grpc.web.MethodDescriptor(
  '/vendormanagement.Vendor/ListVendorEvaluationCriteria',
  grpc.web.MethodType.UNARY,
  proto.vendormanagement.ListVendorEvaluationCriteriaRequest,
  proto.vendormanagement.ListVendorEvaluationCriteriaResponse,
  /**
   * @param {!proto.vendormanagement.ListVendorEvaluationCriteriaRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.vendormanagement.ListVendorEvaluationCriteriaResponse.deserializeBinary
);


/**
 * @param {!proto.vendormanagement.ListVendorEvaluationCriteriaRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.vendormanagement.ListVendorEvaluationCriteriaResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.vendormanagement.ListVendorEvaluationCriteriaResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.vendormanagement.VendorClient.prototype.listVendorEvaluationCriteria =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/vendormanagement.Vendor/ListVendorEvaluationCriteria',
      request,
      metadata || {},
      methodDescriptor_Vendor_ListVendorEvaluationCriteria,
      callback);
};


/**
 * @param {!proto.vendormanagement.ListVendorEvaluationCriteriaRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.vendormanagement.ListVendorEvaluationCriteriaResponse>}
 *     Promise that resolves to the response
 */
proto.vendormanagement.VendorPromiseClient.prototype.listVendorEvaluationCriteria =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/vendormanagement.Vendor/ListVendorEvaluationCriteria',
      request,
      metadata || {},
      methodDescriptor_Vendor_ListVendorEvaluationCriteria);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.vendormanagement.CreateVendorEvaluationCriteriaRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Vendor_CreateVendorEvaluationCriteria = new grpc.web.MethodDescriptor(
  '/vendormanagement.Vendor/CreateVendorEvaluationCriteria',
  grpc.web.MethodType.UNARY,
  proto.vendormanagement.CreateVendorEvaluationCriteriaRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.vendormanagement.CreateVendorEvaluationCriteriaRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.vendormanagement.CreateVendorEvaluationCriteriaRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.vendormanagement.VendorClient.prototype.createVendorEvaluationCriteria =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/vendormanagement.Vendor/CreateVendorEvaluationCriteria',
      request,
      metadata || {},
      methodDescriptor_Vendor_CreateVendorEvaluationCriteria,
      callback);
};


/**
 * @param {!proto.vendormanagement.CreateVendorEvaluationCriteriaRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.vendormanagement.VendorPromiseClient.prototype.createVendorEvaluationCriteria =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/vendormanagement.Vendor/CreateVendorEvaluationCriteria',
      request,
      metadata || {},
      methodDescriptor_Vendor_CreateVendorEvaluationCriteria);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.vendormanagement.UpdateVendorEvaluationCriteriaRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Vendor_UpdateVendorEvaluationCriteria = new grpc.web.MethodDescriptor(
  '/vendormanagement.Vendor/UpdateVendorEvaluationCriteria',
  grpc.web.MethodType.UNARY,
  proto.vendormanagement.UpdateVendorEvaluationCriteriaRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.vendormanagement.UpdateVendorEvaluationCriteriaRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.vendormanagement.UpdateVendorEvaluationCriteriaRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.vendormanagement.VendorClient.prototype.updateVendorEvaluationCriteria =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/vendormanagement.Vendor/UpdateVendorEvaluationCriteria',
      request,
      metadata || {},
      methodDescriptor_Vendor_UpdateVendorEvaluationCriteria,
      callback);
};


/**
 * @param {!proto.vendormanagement.UpdateVendorEvaluationCriteriaRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.vendormanagement.VendorPromiseClient.prototype.updateVendorEvaluationCriteria =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/vendormanagement.Vendor/UpdateVendorEvaluationCriteria',
      request,
      metadata || {},
      methodDescriptor_Vendor_UpdateVendorEvaluationCriteria);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.vendormanagement.DeleteVendorEvaluationCriteriaRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Vendor_DeleteVendorEvaluationCriteria = new grpc.web.MethodDescriptor(
  '/vendormanagement.Vendor/DeleteVendorEvaluationCriteria',
  grpc.web.MethodType.UNARY,
  proto.vendormanagement.DeleteVendorEvaluationCriteriaRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.vendormanagement.DeleteVendorEvaluationCriteriaRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.vendormanagement.DeleteVendorEvaluationCriteriaRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.vendormanagement.VendorClient.prototype.deleteVendorEvaluationCriteria =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/vendormanagement.Vendor/DeleteVendorEvaluationCriteria',
      request,
      metadata || {},
      methodDescriptor_Vendor_DeleteVendorEvaluationCriteria,
      callback);
};


/**
 * @param {!proto.vendormanagement.DeleteVendorEvaluationCriteriaRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.vendormanagement.VendorPromiseClient.prototype.deleteVendorEvaluationCriteria =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/vendormanagement.Vendor/DeleteVendorEvaluationCriteria',
      request,
      metadata || {},
      methodDescriptor_Vendor_DeleteVendorEvaluationCriteria);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.vendormanagement.ListVendorEvaluationCriteriaVersionsRequest,
 *   !proto.vendormanagement.ListVendorEvaluationCriteriaVersionsResponse>}
 */
const methodDescriptor_Vendor_ListVendorEvaluationCriteriaVersions = new grpc.web.MethodDescriptor(
  '/vendormanagement.Vendor/ListVendorEvaluationCriteriaVersions',
  grpc.web.MethodType.UNARY,
  proto.vendormanagement.ListVendorEvaluationCriteriaVersionsRequest,
  proto.vendormanagement.ListVendorEvaluationCriteriaVersionsResponse,
  /**
   * @param {!proto.vendormanagement.ListVendorEvaluationCriteriaVersionsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.vendormanagement.ListVendorEvaluationCriteriaVersionsResponse.deserializeBinary
);


/**
 * @param {!proto.vendormanagement.ListVendorEvaluationCriteriaVersionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.vendormanagement.ListVendorEvaluationCriteriaVersionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.vendormanagement.ListVendorEvaluationCriteriaVersionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.vendormanagement.VendorClient.prototype.listVendorEvaluationCriteriaVersions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/vendormanagement.Vendor/ListVendorEvaluationCriteriaVersions',
      request,
      metadata || {},
      methodDescriptor_Vendor_ListVendorEvaluationCriteriaVersions,
      callback);
};


/**
 * @param {!proto.vendormanagement.ListVendorEvaluationCriteriaVersionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.vendormanagement.ListVendorEvaluationCriteriaVersionsResponse>}
 *     Promise that resolves to the response
 */
proto.vendormanagement.VendorPromiseClient.prototype.listVendorEvaluationCriteriaVersions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/vendormanagement.Vendor/ListVendorEvaluationCriteriaVersions',
      request,
      metadata || {},
      methodDescriptor_Vendor_ListVendorEvaluationCriteriaVersions);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.vendormanagement.ListVendorOrchestrationGuidanceRequest,
 *   !proto.vendormanagement.ListVendorOrchestrationGuidanceResponse>}
 */
const methodDescriptor_Vendor_ListVendorOrchestrationGuidance = new grpc.web.MethodDescriptor(
  '/vendormanagement.Vendor/ListVendorOrchestrationGuidance',
  grpc.web.MethodType.UNARY,
  proto.vendormanagement.ListVendorOrchestrationGuidanceRequest,
  proto.vendormanagement.ListVendorOrchestrationGuidanceResponse,
  /**
   * @param {!proto.vendormanagement.ListVendorOrchestrationGuidanceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.vendormanagement.ListVendorOrchestrationGuidanceResponse.deserializeBinary
);


/**
 * @param {!proto.vendormanagement.ListVendorOrchestrationGuidanceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.vendormanagement.ListVendorOrchestrationGuidanceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.vendormanagement.ListVendorOrchestrationGuidanceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.vendormanagement.VendorClient.prototype.listVendorOrchestrationGuidance =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/vendormanagement.Vendor/ListVendorOrchestrationGuidance',
      request,
      metadata || {},
      methodDescriptor_Vendor_ListVendorOrchestrationGuidance,
      callback);
};


/**
 * @param {!proto.vendormanagement.ListVendorOrchestrationGuidanceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.vendormanagement.ListVendorOrchestrationGuidanceResponse>}
 *     Promise that resolves to the response
 */
proto.vendormanagement.VendorPromiseClient.prototype.listVendorOrchestrationGuidance =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/vendormanagement.Vendor/ListVendorOrchestrationGuidance',
      request,
      metadata || {},
      methodDescriptor_Vendor_ListVendorOrchestrationGuidance);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.vendormanagement.CreateVendorOrchestrationGuidanceRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Vendor_CreateVendorOrchestrationGuidance = new grpc.web.MethodDescriptor(
  '/vendormanagement.Vendor/CreateVendorOrchestrationGuidance',
  grpc.web.MethodType.UNARY,
  proto.vendormanagement.CreateVendorOrchestrationGuidanceRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.vendormanagement.CreateVendorOrchestrationGuidanceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.vendormanagement.CreateVendorOrchestrationGuidanceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.vendormanagement.VendorClient.prototype.createVendorOrchestrationGuidance =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/vendormanagement.Vendor/CreateVendorOrchestrationGuidance',
      request,
      metadata || {},
      methodDescriptor_Vendor_CreateVendorOrchestrationGuidance,
      callback);
};


/**
 * @param {!proto.vendormanagement.CreateVendorOrchestrationGuidanceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.vendormanagement.VendorPromiseClient.prototype.createVendorOrchestrationGuidance =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/vendormanagement.Vendor/CreateVendorOrchestrationGuidance',
      request,
      metadata || {},
      methodDescriptor_Vendor_CreateVendorOrchestrationGuidance);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.vendormanagement.UpdateVendorOrchestrationGuidanceRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Vendor_UpdateVendorOrchestrationGuidance = new grpc.web.MethodDescriptor(
  '/vendormanagement.Vendor/UpdateVendorOrchestrationGuidance',
  grpc.web.MethodType.UNARY,
  proto.vendormanagement.UpdateVendorOrchestrationGuidanceRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.vendormanagement.UpdateVendorOrchestrationGuidanceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.vendormanagement.UpdateVendorOrchestrationGuidanceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.vendormanagement.VendorClient.prototype.updateVendorOrchestrationGuidance =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/vendormanagement.Vendor/UpdateVendorOrchestrationGuidance',
      request,
      metadata || {},
      methodDescriptor_Vendor_UpdateVendorOrchestrationGuidance,
      callback);
};


/**
 * @param {!proto.vendormanagement.UpdateVendorOrchestrationGuidanceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.vendormanagement.VendorPromiseClient.prototype.updateVendorOrchestrationGuidance =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/vendormanagement.Vendor/UpdateVendorOrchestrationGuidance',
      request,
      metadata || {},
      methodDescriptor_Vendor_UpdateVendorOrchestrationGuidance);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.vendormanagement.DeleteVendorOrchestrationGuidanceRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Vendor_DeleteVendorOrchestrationGuidance = new grpc.web.MethodDescriptor(
  '/vendormanagement.Vendor/DeleteVendorOrchestrationGuidance',
  grpc.web.MethodType.UNARY,
  proto.vendormanagement.DeleteVendorOrchestrationGuidanceRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.vendormanagement.DeleteVendorOrchestrationGuidanceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.vendormanagement.DeleteVendorOrchestrationGuidanceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.vendormanagement.VendorClient.prototype.deleteVendorOrchestrationGuidance =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/vendormanagement.Vendor/DeleteVendorOrchestrationGuidance',
      request,
      metadata || {},
      methodDescriptor_Vendor_DeleteVendorOrchestrationGuidance,
      callback);
};


/**
 * @param {!proto.vendormanagement.DeleteVendorOrchestrationGuidanceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.vendormanagement.VendorPromiseClient.prototype.deleteVendorOrchestrationGuidance =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/vendormanagement.Vendor/DeleteVendorOrchestrationGuidance',
      request,
      metadata || {},
      methodDescriptor_Vendor_DeleteVendorOrchestrationGuidance);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.vendormanagement.ListVendorOrchestrationGuidanceVersionsRequest,
 *   !proto.vendormanagement.ListVendorOrchestrationGuidanceVersionsResponse>}
 */
const methodDescriptor_Vendor_ListVendorOrchestrationGuidanceVersions = new grpc.web.MethodDescriptor(
  '/vendormanagement.Vendor/ListVendorOrchestrationGuidanceVersions',
  grpc.web.MethodType.UNARY,
  proto.vendormanagement.ListVendorOrchestrationGuidanceVersionsRequest,
  proto.vendormanagement.ListVendorOrchestrationGuidanceVersionsResponse,
  /**
   * @param {!proto.vendormanagement.ListVendorOrchestrationGuidanceVersionsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.vendormanagement.ListVendorOrchestrationGuidanceVersionsResponse.deserializeBinary
);


/**
 * @param {!proto.vendormanagement.ListVendorOrchestrationGuidanceVersionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.vendormanagement.ListVendorOrchestrationGuidanceVersionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.vendormanagement.ListVendorOrchestrationGuidanceVersionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.vendormanagement.VendorClient.prototype.listVendorOrchestrationGuidanceVersions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/vendormanagement.Vendor/ListVendorOrchestrationGuidanceVersions',
      request,
      metadata || {},
      methodDescriptor_Vendor_ListVendorOrchestrationGuidanceVersions,
      callback);
};


/**
 * @param {!proto.vendormanagement.ListVendorOrchestrationGuidanceVersionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.vendormanagement.ListVendorOrchestrationGuidanceVersionsResponse>}
 *     Promise that resolves to the response
 */
proto.vendormanagement.VendorPromiseClient.prototype.listVendorOrchestrationGuidanceVersions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/vendormanagement.Vendor/ListVendorOrchestrationGuidanceVersions',
      request,
      metadata || {},
      methodDescriptor_Vendor_ListVendorOrchestrationGuidanceVersions);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.vendormanagement.VendorInternalServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.vendormanagement.VendorInternalServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.vendormanagement.CreateVendorsInternalRequest,
 *   !proto.vendormanagement.CreateVendorsInternalResponse>}
 */
const methodDescriptor_VendorInternalService_CreateVendors = new grpc.web.MethodDescriptor(
  '/vendormanagement.VendorInternalService/CreateVendors',
  grpc.web.MethodType.UNARY,
  proto.vendormanagement.CreateVendorsInternalRequest,
  proto.vendormanagement.CreateVendorsInternalResponse,
  /**
   * @param {!proto.vendormanagement.CreateVendorsInternalRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.vendormanagement.CreateVendorsInternalResponse.deserializeBinary
);


/**
 * @param {!proto.vendormanagement.CreateVendorsInternalRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.vendormanagement.CreateVendorsInternalResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.vendormanagement.CreateVendorsInternalResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.vendormanagement.VendorInternalServiceClient.prototype.createVendors =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/vendormanagement.VendorInternalService/CreateVendors',
      request,
      metadata || {},
      methodDescriptor_VendorInternalService_CreateVendors,
      callback);
};


/**
 * @param {!proto.vendormanagement.CreateVendorsInternalRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.vendormanagement.CreateVendorsInternalResponse>}
 *     Promise that resolves to the response
 */
proto.vendormanagement.VendorInternalServicePromiseClient.prototype.createVendors =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/vendormanagement.VendorInternalService/CreateVendors',
      request,
      metadata || {},
      methodDescriptor_VendorInternalService_CreateVendors);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.vendormanagement.LinkVendorRisksRequest,
 *   !proto.vendormanagement.LinkVendorRisksResponse>}
 */
const methodDescriptor_VendorInternalService_LinkVendorRisks = new grpc.web.MethodDescriptor(
  '/vendormanagement.VendorInternalService/LinkVendorRisks',
  grpc.web.MethodType.UNARY,
  proto.vendormanagement.LinkVendorRisksRequest,
  proto.vendormanagement.LinkVendorRisksResponse,
  /**
   * @param {!proto.vendormanagement.LinkVendorRisksRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.vendormanagement.LinkVendorRisksResponse.deserializeBinary
);


/**
 * @param {!proto.vendormanagement.LinkVendorRisksRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.vendormanagement.LinkVendorRisksResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.vendormanagement.LinkVendorRisksResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.vendormanagement.VendorInternalServiceClient.prototype.linkVendorRisks =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/vendormanagement.VendorInternalService/LinkVendorRisks',
      request,
      metadata || {},
      methodDescriptor_VendorInternalService_LinkVendorRisks,
      callback);
};


/**
 * @param {!proto.vendormanagement.LinkVendorRisksRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.vendormanagement.LinkVendorRisksResponse>}
 *     Promise that resolves to the response
 */
proto.vendormanagement.VendorInternalServicePromiseClient.prototype.linkVendorRisks =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/vendormanagement.VendorInternalService/LinkVendorRisks',
      request,
      metadata || {},
      methodDescriptor_VendorInternalService_LinkVendorRisks);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.vendormanagement.AddVendorUserInternalRequest,
 *   !proto.vendormanagement.AddVendorUserInternalResponse>}
 */
const methodDescriptor_VendorInternalService_AddVendorUser = new grpc.web.MethodDescriptor(
  '/vendormanagement.VendorInternalService/AddVendorUser',
  grpc.web.MethodType.UNARY,
  proto.vendormanagement.AddVendorUserInternalRequest,
  proto.vendormanagement.AddVendorUserInternalResponse,
  /**
   * @param {!proto.vendormanagement.AddVendorUserInternalRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.vendormanagement.AddVendorUserInternalResponse.deserializeBinary
);


/**
 * @param {!proto.vendormanagement.AddVendorUserInternalRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.vendormanagement.AddVendorUserInternalResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.vendormanagement.AddVendorUserInternalResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.vendormanagement.VendorInternalServiceClient.prototype.addVendorUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/vendormanagement.VendorInternalService/AddVendorUser',
      request,
      metadata || {},
      methodDescriptor_VendorInternalService_AddVendorUser,
      callback);
};


/**
 * @param {!proto.vendormanagement.AddVendorUserInternalRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.vendormanagement.AddVendorUserInternalResponse>}
 *     Promise that resolves to the response
 */
proto.vendormanagement.VendorInternalServicePromiseClient.prototype.addVendorUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/vendormanagement.VendorInternalService/AddVendorUser',
      request,
      metadata || {},
      methodDescriptor_VendorInternalService_AddVendorUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.vendormanagement.UpdateVendorEvaluationCycleRequest,
 *   !proto.vendormanagement.VendorEvaluationCycle>}
 */
const methodDescriptor_VendorInternalService_UpdateVendorEvaluationCycle = new grpc.web.MethodDescriptor(
  '/vendormanagement.VendorInternalService/UpdateVendorEvaluationCycle',
  grpc.web.MethodType.UNARY,
  vendormanagement_vendor_evaluation_cycle_pb.UpdateVendorEvaluationCycleRequest,
  vendormanagement_vendor_evaluation_cycle_pb.VendorEvaluationCycle,
  /**
   * @param {!proto.vendormanagement.UpdateVendorEvaluationCycleRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  vendormanagement_vendor_evaluation_cycle_pb.VendorEvaluationCycle.deserializeBinary
);


/**
 * @param {!proto.vendormanagement.UpdateVendorEvaluationCycleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.vendormanagement.VendorEvaluationCycle)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.vendormanagement.VendorEvaluationCycle>|undefined}
 *     The XHR Node Readable Stream
 */
proto.vendormanagement.VendorInternalServiceClient.prototype.updateVendorEvaluationCycle =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/vendormanagement.VendorInternalService/UpdateVendorEvaluationCycle',
      request,
      metadata || {},
      methodDescriptor_VendorInternalService_UpdateVendorEvaluationCycle,
      callback);
};


/**
 * @param {!proto.vendormanagement.UpdateVendorEvaluationCycleRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.vendormanagement.VendorEvaluationCycle>}
 *     Promise that resolves to the response
 */
proto.vendormanagement.VendorInternalServicePromiseClient.prototype.updateVendorEvaluationCycle =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/vendormanagement.VendorInternalService/UpdateVendorEvaluationCycle',
      request,
      metadata || {},
      methodDescriptor_VendorInternalService_UpdateVendorEvaluationCycle);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.vendormanagement.ConcludeVendorEvaluationCycleRequest,
 *   !proto.vendormanagement.VendorEvaluationCycle>}
 */
const methodDescriptor_VendorInternalService_ConcludeVendorEvaluationCycle = new grpc.web.MethodDescriptor(
  '/vendormanagement.VendorInternalService/ConcludeVendorEvaluationCycle',
  grpc.web.MethodType.UNARY,
  vendormanagement_vendor_evaluation_cycle_pb.ConcludeVendorEvaluationCycleRequest,
  vendormanagement_vendor_evaluation_cycle_pb.VendorEvaluationCycle,
  /**
   * @param {!proto.vendormanagement.ConcludeVendorEvaluationCycleRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  vendormanagement_vendor_evaluation_cycle_pb.VendorEvaluationCycle.deserializeBinary
);


/**
 * @param {!proto.vendormanagement.ConcludeVendorEvaluationCycleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.vendormanagement.VendorEvaluationCycle)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.vendormanagement.VendorEvaluationCycle>|undefined}
 *     The XHR Node Readable Stream
 */
proto.vendormanagement.VendorInternalServiceClient.prototype.concludeVendorEvaluationCycle =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/vendormanagement.VendorInternalService/ConcludeVendorEvaluationCycle',
      request,
      metadata || {},
      methodDescriptor_VendorInternalService_ConcludeVendorEvaluationCycle,
      callback);
};


/**
 * @param {!proto.vendormanagement.ConcludeVendorEvaluationCycleRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.vendormanagement.VendorEvaluationCycle>}
 *     Promise that resolves to the response
 */
proto.vendormanagement.VendorInternalServicePromiseClient.prototype.concludeVendorEvaluationCycle =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/vendormanagement.VendorInternalService/ConcludeVendorEvaluationCycle',
      request,
      metadata || {},
      methodDescriptor_VendorInternalService_ConcludeVendorEvaluationCycle);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.vendormanagement.RefreshVendorEvaluationStatusRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_VendorInternalService_RefreshVendorEvaluationStatus = new grpc.web.MethodDescriptor(
  '/vendormanagement.VendorInternalService/RefreshVendorEvaluationStatus',
  grpc.web.MethodType.UNARY,
  vendormanagement_vendor_evaluation_cycle_pb.RefreshVendorEvaluationStatusRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.vendormanagement.RefreshVendorEvaluationStatusRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.vendormanagement.RefreshVendorEvaluationStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.vendormanagement.VendorInternalServiceClient.prototype.refreshVendorEvaluationStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/vendormanagement.VendorInternalService/RefreshVendorEvaluationStatus',
      request,
      metadata || {},
      methodDescriptor_VendorInternalService_RefreshVendorEvaluationStatus,
      callback);
};


/**
 * @param {!proto.vendormanagement.RefreshVendorEvaluationStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.vendormanagement.VendorInternalServicePromiseClient.prototype.refreshVendorEvaluationStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/vendormanagement.VendorInternalService/RefreshVendorEvaluationStatus',
      request,
      metadata || {},
      methodDescriptor_VendorInternalService_RefreshVendorEvaluationStatus);
};


module.exports = proto.vendormanagement;

